import moment from 'moment';

export function getDateInTimeZone(date, timezone = 'America/Los_Angeles') {
  if (!date) {
    return null;
  }
  const dateOnly = moment(date).format('YYYY-MM-DD');
  const result = moment.tz(dateOnly, ['YYYY-MM-DD'], timezone);
  return result.format();
}
